import React from 'react';
import CustomerDetailContainer from 'containers/CustomerDetail';

const CustomerDetail = (props) => {
  return (
    <>
     <CustomerDetailContainer {...props} />
    </>
  );
};

export default CustomerDetail;
 